import type { AnalyticsProvider, TrackInput } from "../types";

// Plausible custom-event API. Domain must match the site registered in
// the Plausible dashboard.
// Env: PLAUSIBLE_DOMAIN (or VITE_PLAUSIBLE_DOMAIN)
export const plausibleAnalyticsProvider: AnalyticsProvider = {
  name: "plausible",
  async track(input: TrackInput) {
    const domain = readDomain();
    if (!domain) {
      console.error("[analytics:plausible] domain_missing");
      return undefined;
    }
    const url =
      typeof window !== "undefined" ? window.location.href : `https://${domain}/`;
    try {
      await fetch("https://plausible.io/api/event", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "User-Agent":
            typeof navigator !== "undefined" ? navigator.userAgent : "invoice-intelligence",
        },
        body: JSON.stringify({
          name: input.event,
          url,
          domain,
          props: input.properties,
        }),
        keepalive: true,
      });
    } catch (err) {
      const msg = err instanceof Error ? err.message : "plausible_unknown_error";
      console.error(`[analytics:plausible] ${msg}`);
    }
    return undefined;
  },
};

function readDomain(): string | undefined {
  if (typeof process !== "undefined" && process.env?.PLAUSIBLE_DOMAIN)
    return process.env.PLAUSIBLE_DOMAIN;
  if (typeof import.meta !== "undefined") {
    const v = (import.meta as { env?: Record<string, string | undefined> }).env
      ?.VITE_PLAUSIBLE_DOMAIN;
    if (v) return v;
  }
  return undefined;
}
